import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { useOptionSelectStyles } from './styles'
import { Flex } from 'components/common'

const OptionSelect = ({
  id,
  label,
  value: selectedValue,
  isAddable,
  options = [],
  onChange = () => {},
  onAdd = () => {},
  ...props
}) => {
  const classes = useOptionSelectStyles()
  return (
    <div className={classes.optionSelectWrapper}>
      {label && <label id={`${id || 'select'}-label`}>{label}</label>}
      <Flex alignCenter>
        <div className="btn-group btn-group-stack-full-xs" id={id} {...props}>
          {options.map(({ label, value, disabled }) => {
            const isActive = selectedValue && value === selectedValue.value
            return (
              <button
                key={value}
                className={classnames('btn btn-flat', {
                  active: isActive
                })}
                disabled={disabled}
                id={`option-${value}`}
                onClick={() => onChange({ label, value })}
              >
                {label}
              </button>
            )
          })}
        </div>
        {isAddable && (
          <i className="icon add-category" onClick={onAdd}>
            add
          </i>
        )}
      </Flex>
    </div>
  )
}

OptionSelect.OptionShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool
})

OptionSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: OptionSelect.OptionShape,
  isAddable: PropTypes.bool,
  options: PropTypes.arrayOf(OptionSelect.OptionShape),
  onChange: PropTypes.func,
  onAdd: PropTypes.func
}

export default OptionSelect
